import { render, staticRenderFns } from "./UnderwriterInfo.vue?vue&type=template&id=5e06b72c"
import script from "./UnderwriterInfo.vue?vue&type=script&lang=ts"
export * from "./UnderwriterInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports